(function () {
  'use strict';
  var C = window.IKIDO_POPUP || {};
  var KEY = C.key, LIST = C.list;
  var CODE = C.code || 'IKIDO10';
  var PCT = C.percent || 10;
  var DELAY = C.delayMs || 3500;
  var REDAYS = C.redisplayDays || 30;
  var SK = 'ikido_popup_v1';
  if (!KEY || !LIST) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var priorMinimized = false;
  try {
    var raw = localStorage.getItem(SK);
    if (raw) {
      var st = JSON.parse(raw);
      if (st && st.ts && (Date.now() - st.ts) < REDAYS * 86400000) {
        if (st.status === 'minimized') { priorMinimized = true; }
        else { return; }
      }
    }
  } catch (e) {}

  function save(status) { try { localStorage.setItem(SK, JSON.stringify({ status: status, ts: Date.now() })); } catch (e) {} }
  function el(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstChild; }

  function injectStyles() {
    if (document.getElementById('ikido-pop-css')) return;
    var s = document.createElement('style'); s.id = 'ikido-pop-css';
    s.textContent = [
      '.ikido-pop{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.55);opacity:0;transition:opacity .25s ease;}',
      '.ikido-pop.is-open{opacity:1;}',
      '.ikido-pop__card{position:relative;width:100%;max-width:420px;background:rgb(var(--color-background,255,255,255));color:rgb(var(--color-foreground,26,26,26));border-radius:12px;padding:34px 26px 26px;box-shadow:0 20px 60px rgba(0,0,0,.3);transform:translateY(12px);transition:transform .25s ease;text-align:center;}',
      '.ikido-pop.is-open .ikido-pop__card{transform:none;}',
      '.ikido-pop__close{position:absolute;top:8px;right:12px;background:none;border:0;font-size:26px;line-height:1;cursor:pointer;color:inherit;opacity:.5;}',
      '.ikido-pop__close:hover{opacity:1;}',
      '.ikido-pop__eyebrow{font-size:1.1rem;letter-spacing:.14em;text-transform:uppercase;opacity:.55;margin:0 0 8px;}',
      '.ikido-pop__title{font-size:2.4rem;line-height:1.15;margin:0 0 10px;font-weight:600;}',
      '.ikido-pop__sub{font-size:1.4rem;line-height:1.4;opacity:.8;margin:0 0 18px;}',
      '.ikido-pop__form{display:flex;flex-direction:column;gap:10px;}',
      '.ikido-pop__input{width:100%;padding:13px 14px;font-size:1.5rem;border:1px solid rgba(var(--color-foreground,26,26,26),.28);border-radius:var(--inputs-radius,6px);background:transparent;color:inherit;box-sizing:border-box;}',
      '.ikido-pop__btn{display:block;width:100%;padding:14px;font-size:1.5rem;font-weight:600;border:0;border-radius:var(--buttons-radius,6px);background:rgb(var(--color-button,26,26,26));color:rgb(var(--color-button-text,255,255,255));cursor:pointer;text-decoration:none;box-sizing:border-box;}',
      '.ikido-pop__btn[disabled]{opacity:.6;cursor:default;}',
      '.ikido-pop__err{color:#c0392b;font-size:1.2rem;min-height:1.2rem;margin:2px 0 0;}',
      '.ikido-pop__no{display:inline-block;margin-top:12px;font-size:1.2rem;opacity:.6;text-decoration:underline;background:none;border:0;cursor:pointer;color:inherit;}',
      '.ikido-pop__fine{font-size:1.05rem;opacity:.5;margin:14px 0 0;line-height:1.4;}',
      '.ikido-pop__code{display:flex;align-items:center;justify-content:center;gap:10px;margin:8px 0 16px;flex-wrap:wrap;}',
      '.ikido-pop__codebox{font-size:2rem;font-weight:700;letter-spacing:.08em;border:2px dashed rgba(var(--color-foreground,26,26,26),.4);border-radius:8px;padding:10px 18px;}',
      '.ikido-pop__copy{padding:10px 14px;font-size:1.3rem;border:1px solid rgba(var(--color-foreground,26,26,26),.3);border-radius:6px;background:transparent;color:inherit;cursor:pointer;}',
      '.ikido-tab{position:fixed;left:0;top:50%;transform:translate(-105%,-50%);z-index:99998;display:flex;flex-direction:column;align-items:center;gap:6px;background:rgb(var(--color-button,26,26,26));color:rgb(var(--color-button-text,255,255,255));padding:14px 9px;border-radius:0 8px 8px 0;box-shadow:0 6px 24px rgba(0,0,0,.28);transition:transform .3s ease;}',
      '.ikido-tab.is-in{transform:translate(0,-50%);}',
      '.ikido-tab__x{background:none;border:0;color:inherit;font-size:16px;line-height:1;cursor:pointer;opacity:.6;padding:0;margin:0 0 2px;}',
      '.ikido-tab__x:hover{opacity:1;}',
      '.ikido-tab__btn{background:none;border:0;color:inherit;cursor:pointer;font-size:1.15rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;writing-mode:vertical-rl;transform:rotate(180deg);padding:4px 0;}'
    ].join('');
    document.head.appendChild(s);
  }

  var pop, opened = false, hasSigned = false;
  function escClose(e) { if (e.key === 'Escape') dismiss(); }
  function open() {
    if (opened) return; opened = true;
    injectStyles();
    pop = el('<div class="ikido-pop"><div class="ikido-pop__card"><button class="ikido-pop__close" aria-label="Close">×</button><div class="ikido-pop__body"></div></div></div>');
    document.body.appendChild(pop);
    renderForm();
    requestAnimationFrame(function () { pop.classList.add('is-open'); });
    pop.querySelector('.ikido-pop__close').addEventListener('click', dismiss);
    pop.addEventListener('click', function (e) { if (e.target === pop) dismiss(); });
    document.addEventListener('keydown', escClose);
  }
  function close() {
    if (!pop) return;
    opened = false;
    document.removeEventListener('keydown', escClose);
    pop.classList.remove('is-open');
    var p = pop; pop = null;
    setTimeout(function () { if (p && p.parentNode) p.parentNode.removeChild(p); }, 250);
  }
  function dismiss() {
    if (hasSigned) { save('signed'); close(); return; }
    save('minimized'); close(); showTab();
  }

  function showTab() {
    if (document.getElementById('ikido-pop-tab')) return;
    injectStyles();
    var tab = el('<div class="ikido-tab" id="ikido-pop-tab"><button class="ikido-tab__x" aria-label="Dismiss offer">×</button><button class="ikido-tab__btn" aria-label="Open the ' + PCT + '% off offer">Get ' + PCT + '% off</button></div>');
    document.body.appendChild(tab);
    requestAnimationFrame(function () { tab.classList.add('is-in'); });
    tab.querySelector('.ikido-tab__btn').addEventListener('click', function () { removeTab(); open(); });
    tab.querySelector('.ikido-tab__x').addEventListener('click', function (e) { e.stopPropagation(); save('closed'); removeTab(); });
  }
  function removeTab() {
    var t = document.getElementById('ikido-pop-tab');
    if (!t) return;
    t.classList.remove('is-in');
    setTimeout(function () { if (t && t.parentNode) t.parentNode.removeChild(t); }, 300);
  }

  function renderForm() {
    var body = pop.querySelector('.ikido-pop__body');
    body.innerHTML =
      '<p class="ikido-pop__eyebrow">IKIDO</p>' +
      '<h2 class="ikido-pop__title">Get ' + PCT + '% off your first order</h2>' +
      '<p class="ikido-pop__sub">Join our list for ' + PCT + '% off, new arrivals, and Toronto showroom events.</p>' +
      '<form class="ikido-pop__form" novalidate><input type="email" class="ikido-pop__input" placeholder="Enter your email" autocomplete="email" required><button type="submit" class="ikido-pop__btn">Get my ' + PCT + '% code</button><p class="ikido-pop__err" aria-live="polite"></p></form>' +
      '<button type="button" class="ikido-pop__no">No thanks</button>' +
      '<p class="ikido-pop__fine">By signing up you agree to receive email marketing from IKIDO. Unsubscribe anytime.</p>';
    var form = body.querySelector('form');
    var input = body.querySelector('.ikido-pop__input');
    var err = body.querySelector('.ikido-pop__err');
    var btn = body.querySelector('.ikido-pop__btn');
    body.querySelector('.ikido-pop__no').addEventListener('click', dismiss);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { err.textContent = 'Please enter a valid email.'; return; }
      err.textContent = ''; btn.disabled = true; btn.textContent = 'Signing you up…';
      subscribe(email).then(function () {}).catch(function () {}).then(function () { hasSigned = true; save('signed'); renderSuccess(); });
    });
    setTimeout(function () { try { input.focus(); } catch (e) {} }, 120);
  }

  function subscribe(email) {
    try {
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KEY), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: LIST } } } } })
      });
    } catch (e) { return Promise.resolve(); }
  }

  function shopUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/collections/best-sellers?discount=' + encodeURIComponent(CODE);
  }

  function renderSuccess() {
    var body = pop.querySelector('.ikido-pop__body');
    body.innerHTML =
      '<p class="ikido-pop__eyebrow">You’re in</p>' +
      '<h2 class="ikido-pop__title">Here’s your ' + PCT + '% off</h2>' +
      '<p class="ikido-pop__sub">Use this code at checkout — we’ve saved it below.</p>' +
      '<div class="ikido-pop__code"><span class="ikido-pop__codebox">' + CODE + '</span><button type="button" class="ikido-pop__copy">Copy</button></div>' +
      '<a class="ikido-pop__btn" href="' + shopUrl() + '">Shop now</a>' +
      '<p class="ikido-pop__fine">Check your inbox to confirm your subscription.</p>';
    var copy = body.querySelector('.ikido-pop__copy');
    copy.addEventListener('click', function () { try { navigator.clipboard.writeText(CODE); } catch (e) {} copy.textContent = 'Copied!'; });
  }

  function schedule() {
    if (priorMinimized) { showTab(); return; }
    var t = setTimeout(open, DELAY);
    if (window.matchMedia && window.matchMedia('(min-width:750px)').matches) {
      document.addEventListener('mouseout', function onOut(e) {
        if (e.clientY <= 0 && !e.relatedTarget) { clearTimeout(t); document.removeEventListener('mouseout', onOut); open(); }
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
